import Vue from 'vue'
import 'animate.css'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import { firebase, i18n } from '@/plugins'
import '@/interceptors'
import '@/directives'

import '@/assets/styles/index.scss'

import * as rules from '@/utils/rules'

Vue.prototype.$rules = rules
Vue.prototype.$firebase = firebase
// Vue.prototype.$Paddle = Paddle

// eslint-disable-next-line no-undef
console.info('Build timestamp:', __BUILD_TIMESTAMP__)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
